import * as React from "react";
import type { SVGProps } from "react";
const SvgRectangleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="rectangle_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M796.16 166.784a61.056 61.056 0 1 0 0 122.112 61.056 61.056 0 0 0 0-122.112zm-467.03 83.115a79.232 79.232 0 0 0-79.23 79.231v326.23a142.635 142.635 0 0 1 118.74 118.741h326.23a79.232 79.232 0 0 0 79.23-79.231V368.64a142.635 142.635 0 0 1-118.74-118.741H329.13zm-164.565 418.56V329.088a164.565 164.565 0 0 1 164.566-164.565h339.285A142.507 142.507 0 1 1 859.435 355.54v339.286a164.565 164.565 0 0 1-164.566 164.565H355.584a142.507 142.507 0 1 1-191.019-191.019zm2.219 127.701a61.056 61.056 0 1 0 122.112 0 61.056 61.056 0 0 0-122.112 0z"
    />
  </svg>
);
export default SvgRectangleIcon;
